const googleRecaptcha = (googleRecaptchaParameter) => {
    const htmlScriptElement = window.document.createElement("script");
    htmlScriptElement.src = googleRecaptchaParameter.recaptchaJavascriptPath;
    window.document.head.append(htmlScriptElement);
    htmlScriptElement.addEventListener("load", () => {
        const windowGrecaptcha = window["grecaptcha"];
        const windowGrecaptchaEnterprise = windowGrecaptcha["enterprise"];
        windowGrecaptchaEnterprise.ready(() => {
            windowGrecaptchaEnterprise
                .execute(googleRecaptchaParameter.recaptchaSiteKey, { "action": googleRecaptchaParameter.recaptchaActionName })
                .then((_token) => {
                // Save "action" and "token" in global context
            });
        });
    });
};
export { googleRecaptcha };
